// Mirror of backend compute_sale_due in `routers/sales.py`. Keep these in sync.
// Cash is the base; Exchange and Finance can stack independently.
// `Tenders captured` = sum of payment_lines entries the user has added.
//   credits = advance + discount
//             + tenders captured  (from payment_lines; falls back to down_payment if empty)
//             + exchange.amount   (when exchange block active)
//             + finance_amount    (bank pays this directly when finance is on)
//             − finance.commission (dealer earning from financier)
//   Due = OnRoad − credits
export function computeSaleDue(sale) {
  const num = (v) => Number(v) || 0;
  const onRoad = num(sale.on_road_price);
  const advance = num(sale.advance_amount);
  const discount = num(sale.discount);
  // Be lenient with legacy `sale_type` so old data renders correctly.
  const legacy = sale.sale_type || "cash";
  const hasExchange = !!sale.has_exchange || ["exchange", "exchange_finance"].includes(legacy);
  const hasFinance = !!sale.has_finance || ["finance", "exchange_finance"].includes(legacy);

  const lines = Array.isArray(sale.payment_lines) ? sale.payment_lines : [];
  let tenders = lines.reduce((s, l) => s + num(l.amount), 0);
  // Back-compat: older sales (no payment_lines) still carry a down_payment scalar.
  if (tenders === 0) tenders = num(sale.down_payment);

  let credits = advance + discount + tenders;
  if (hasExchange) credits += num(sale.exchange?.amount);
  if (hasFinance) {
    credits += num(sale.finance?.finance_amount);
    credits -= num(sale.finance?.commission_amount);
  }
  return Math.round((onRoad - credits) * 100) / 100;
}

export function paymentLinesTotal(lines = []) {
  return lines.reduce((s, l) => s + (Number(l.amount) || 0), 0);
}
